import { render, staticRenderFns } from "./WhiteLyonLogo.vue?vue&type=template&id=76b5318f&scoped=true&"
var script = {}
import style0 from "./WhiteLyonLogo.vue?vue&type=style&index=0&id=76b5318f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b5318f",
  null
  
)

export default component.exports